import { useTranslation } from "react-i18next";
import { TextInput, Tile } from "@carbon/react";

type Props = {
  /** Whether the file already matched a saved format, which changes what saving it means. */
  hasSavedFormat: boolean;
  formatName: string;
  onFormatNameChange: (name: string) => void;
};

/** What the way of reading this file is saved as, so next month's upload needs no checking. */
const SaveFormatPanel = ({
  hasSavedFormat,
  formatName,
  onFormatNameChange,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Tile className="pr-import__panel">
      <div className="pr-import__panel-head">
        <h3 className="pr-import__title">
          {t("purchaseRequests.import.saveFormat")}
        </h3>
        <p className="pr-import__hint">
          {hasSavedFormat
            ? t("purchaseRequests.import.saveFormatVersionHint")
            : t("purchaseRequests.import.saveFormatHint")}
        </p>
      </div>

      <TextInput
        id="pr-import-format-name"
        labelText={t("purchaseRequests.import.formatNameLabel")}
        placeholder={t("purchaseRequests.import.formatNamePlaceholder")}
        value={formatName}
        onChange={(event) => onFormatNameChange(event.target.value)}
      />
    </Tile>
  );
};

export default SaveFormatPanel;
